// extracted by mini-css-extract-plugin
export default {"masterContainer":"ScreenStart_masterContainer__rCGIV","subtext":"ScreenStart_subtext__Ea1dn","settingsContainer":"ScreenStart_settingsContainer__4PelY"};